export interface CompanyLogoInput {
  logoUrl?: string | null;
  domain?: string | null;
}

/** Resolve logo URL: explicit logoUrl → Clearbit(domain) → undefined (initials fallback). */
export function resolveCompanyLogoUrl(input: CompanyLogoInput): string | undefined {
  const logoUrl = input.logoUrl?.trim();
  if (logoUrl) return logoUrl;

  const domain = input.domain?.trim().toLowerCase().replace(/^www\./, "");
  if (domain) return `https://logo.clearbit.com/${domain}`;

  return undefined;
}
